/**
* Animated Drop List JS
* -----------------------------------------------------------------------------
*
* All the JS for the Animated Drop List component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'animated-drop-list',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.animated-drop-list' ).each( function() {
        const pin = $( this ).find( '.screw' );
        const lowerScrew = $( this ).find( '.screw_lower' );
        const lowerPin = $( this ).find( '.animated-drop-list__video-container' );
        let mobile = false;
        let loggedIn = false;
        if ( window.innerWidth < 1024 ) {
          mobile = true;
        }
        if ( $( '.logged-in' ).length > 0 ) {
          loggedIn = true;
        }

        let top = '88px';
        if ( mobile === true ) {
          top = '64px';
        }
        if ( loggedIn === true && mobile === false ) {
          top = '120px';
        }
        if ( mobile === true && loggedIn === true ) {
          top = '110px';
        }
        $( window ).on( 'resize', function() {
          if ( mobile === true ) {
            top = '64px';
          }
          if ( loggedIn === true && mobile === false ) {
            top = '120px';
          }
          if ( mobile === true && loggedIn === true ) {
            top = '110px';
          }
        } );
        console.log( top );
        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: pin,
            start: 'center center',
            pin: true,
            scrub: 0.15,
            onRefresh: ( self ) => {
              if ( self.progress > 0 ) {
                $( this ).addClass( 'js-animated' );
              }
            },
            onEnter: ( {progress, direction, isActive} ) => $( this ).addClass( 'js-animated' ),
          },
        } );
        // const lower = gsap.timeline( {
        //   scrollTrigger: {
        //     trigger: lowerPin,
        //     start: 'top top+='+top,
        //     pin: true,
        //     markers: true,
        //     scrub: 0.15,
        //     onRefresh: ( self ) => {
        //       if ( self.progress > 0 ) {
        //         $( this ).addClass( 'js-animated' );
        //       }
        //     },
        //     onEnter: ( {progress, direction, isActive} ) => $( this ).addClass( 'js-animated' ),
        //   },
        // } );
        // lower.to( lowerScrew, {opacity: 0} );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'animated-drop-list', COMPONENT );
} )( app );
